// extracted by mini-css-extract-plugin
export default {"card":"mediatheque-card_card__GNCPC"};